/**
 * 扫码领积分 - 积分活动管理页面
 * 
 * 提供积分活动的增删改查功能，包括：
 * - 活动列表展示（含分页、全选、批量删除）
 * - 新增/编辑积分活动（金额设置、产品设置、样式设置）
 * - 活动状态开关切换
 * - 参与人数查看（积分领取记录）
 * - 活动页面样式与积分领取样式图片上传
 * 
 * @component
 * @requires points_active - 积分活动列表接口
 * @requires points_active_status - 积分活动状态切换接口
 * @requires points_active_delete - 积分活动删除接口
 * @requires points_active_info - 积分活动详情接口
 * @requires points_active_save - 积分活动保存接口
 * @requires points_active_user_list - 积分领取用户列表接口
 * @requires product_select - 产品下拉选择接口
 * @requires batch_select - 批次下拉选择接口
 * @requires agent_select - 代理商下拉选择接口
 * @requires VueQr - 二维码生成组件
 * @requires pictureLibrary - 图片库选择组件
 * 
 * @data {Object} storePrams - 列表分页参数（page, limit）
 * @data {number} total - 列表总条数
 * @data {Array} columnsTable - 活动列表表头配置
 * @data {Array} dataTable - 活动列表数据
 * @data {boolean} drawers - 新增/编辑抽屉可见状态
 * @data {string} drawerTitle - 抽屉标题（新增/编辑）
 * @data {Object} formData - 表单数据（id, batch_id, product_id, agent_id, mode, num, points, points_sum, enter_url, style_url, word1, word2, show_enter_url, show_style_url）
 * @data {Array} modeList - 积分模式选项（1:固定积分, 2:随机积分）
 * @data {Array} batchList - 批次下拉数据
 * @data {Array} productList - 产品下拉数据
 * @data {Array} agentList - 代理商下拉数据
 * @data {boolean} countDrawer - 参与人数抽屉可见状态
 * @data {Object} pageCount - 参与人数分页参数（page, limit, id）
 * @data {number} totalCount - 参与人数总条数
 * @data {Array} dataCount - 参与人数列表数据
 * @data {Array} delData - 已选中的行数据（用于批量删除）
 * @data {boolean} delValue - 全选复选框状态
 * @data {number} imgtype - 当前上传图片类型（1:活动页面样式, 2:积分领取样式）
 * @data {boolean} switch_modal - 图片库弹窗可见状态
 */
<!-- 扫码领积分 -->
<template>
    <div class="container">
        <div class="content">
            <div>
                <Button
                    class="theme-bc mb24 theme-default-color"
                    icon="md-add-circle"
                    @click="goDrawer"
                    >新增领积分活动</Button
                >
                <Table
                    ref="selection"
                    :columns="columnsTable"
                    :data="dataTable"
                    border
                    @on-selection-change="goChangeSelection"
                >
                    <template slot-scope="{ row }" slot="product">
                        <div class="flex-c">
                            {{ row.product ? row.product.product_name : "" }}
                        </div>
                    </template>
                    <template
                        slot-scope="{ row }"
                        slot="user_points_sum_points"
                    >
                        <div class="flex-c">
                            {{
                                row.user_points_sum_points
                                    ? row.user_points_sum_points
                                    : 0
                            }}
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="user_points_count">
                        <Button @click="goCount(row)">{{
                            row.user_points_count
                        }}</Button>
                    </template>
                    <template slot-scope="{ row }" slot="status">
                        <div class="flex-c">
                            <i-switch
                                v-model="row.status"
                                size="large"
                                true-color="#FF761D "
                                :true-value="1"
                                :false-value="0"
                                @on-change="goChangeStatus(row, $event)"
                            >
                                <span slot="open">开启</span>
                                <span slot="close">关闭</span>
                            </i-switch>
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <Button type="primary" ghost @click="goDrawer(row)"
                                >编辑</Button
                            >
                            <Button type="error" ghost @click="goDel(1, row)"
                                >删除</Button
                            >
                        </div>
                    </template>
                </Table>
            </div>
            <div class="page-container">
                <div>
                    <Checkbox
                        class="mr24 ml24"
                        v-model="delValue"
                        @on-change="goChangeAll"
                        >全选</Checkbox
                    >
                    <Button type="error" ghost @click="goDel(0)">删除</Button>
                </div>
                <Page
                    :current="storePrams.page"
                    :page-size="storePrams.limit"
                    :total="total"
                    show-elevator
                    show-total
                    @on-change="goChangePage"
                />
            </div>
        </div>
        <!-- 新增/编辑 -->
        <Drawer v-model="drawers" :title="drawerTitle" width="80">
            <Form :model="formData" label-position="right" :label-width="150">
                <div class="form-title">积分设置</div>
                <FormItem label="积分模式：">
                    <Select
                        class="w300"
                        v-model="formData.mode"
                        clearable
                        filterable
                        placeholder="请选择积分模式"
                    >
                        <Option
                            v-for="item in modeList"
                            :value="item.id"
                            :key="item.id"
                            >{{ item.name }}</Option
                        >
                    </Select>
                </FormItem>
                <FormItem label="积分份数：">
                    <Input
                        class="w300"
                        type="text"
                        v-model="formData.num"
                        placeholder="请输入积分份数"
                    ></Input>
                </FormItem>
                <FormItem v-if="formData.mode == 1" label="每份积分数量：">
                    <Input
                        class="w300"
                        type="text"
                        v-model="formData.points"
                        placeholder="请输入每份积分数量"
                    ></Input>
                </FormItem>
                <FormItem v-if="formData.mode == 2" label="积分总数量：">
                    <Input
                        class="w300"
                        type="text"
                        v-model="formData.points_sum"
                        placeholder="请输入积分总数量"
                    ></Input>
                </FormItem>
                <div class="form-title">产品设置</div>
                <FormItem label="产品批次：">
                    <Select
                        class="w300"
                        v-model="formData.batch_id"
                        clearable
                        filterable
                        placeholder="请选择产品批次"
                    >
                        <Option
                            v-for="item in batchList"
                            :value="item.id"
                            :key="item.id"
                            >{{ item.batch_name }}</Option
                        >
                    </Select>
                </FormItem>
                <FormItem label="产品名称：">
                    <Select
                        class="w300"
                        v-model="formData.product_id"
                        clearable
                        filterable
                        placeholder="请选择产品名称"
                    >
                        <Option
                            v-for="item in productList"
                            :value="item.id"
                            :key="item.id"
                            >{{ item.product_name }}</Option
                        >
                    </Select>
                </FormItem>
                <FormItem label="产品代理商：">
                    <Select
                        class="w300"
                        v-model="formData.agent_id"
                        clearable
                        filterable
                        placeholder="请选择产品代理商"
                    >
                        <Option
                            v-for="item in agentList"
                            :value="item.id"
                            :key="item.id"
                            >{{ item.agent_name }}</Option
                        >
                    </Select>
                </FormItem>
                <div class="form-title">样式设置</div>
                <div class="dis-flex">
                    <FormItem label="活动页面样式: ">
                        <div class="dis-flex">
                            <div class="form-upload mr12" @click="openModal(1)">
                                <Icon
                                    type="ios-add"
                                    size="44"
                                    color="#AEAEB3"
                                />
                                <div>尺寸200px 270px</div>
                            </div>
                            <div v-if="formData.enter_url" class="form-img">
                                <img
                                    class="wh100"
                                    :src="formData.show_enter_url"
                                />
                                <Icon
                                    class="img-del"
                                    size="20"
                                    type="ios-close-circle"
                                    color="#f00"
                                    @click="goDelEnter"
                                />
                            </div>
                        </div>
                    </FormItem>
                    <FormItem label="积分领取样式：">
                        <div class="dis-flex">
                            <div class="form-upload mr12" @click="openModal(2)">
                                <Icon
                                    type="ios-add"
                                    size="44"
                                    color="#AEAEB3"
                                />
                                <div>尺寸380px 670px</div>
                            </div>
                            <div v-if="formData.style_url" class="form-img">
                                <img
                                    class="wh100"
                                    :src="formData.show_style_url"
                                />
                                <Icon
                                    class="img-del"
                                    size="20"
                                    type="ios-close-circle"
                                    color="#f00"
                                    @click="goDelStyle"
                                />
                            </div>
                        </div>
                    </FormItem>
                </div>
                <FormItem label="积分文字1设置: ">
                    <Input
                        class="w300"
                        type="text"
                        v-model="formData.word1"
                        placeholder="请输入积分文字"
                    ></Input>
                </FormItem>
                <FormItem label="积分文字2设置: ">
                    <Input
                        class="w300"
                        type="text"
                        v-model="formData.word2"
                        placeholder="请输入积分文字"
                    ></Input>
                </FormItem>
                <div class="footer">
                    <Button @click="goCancelForm">取消</Button>
                    <Button
                        class="theme-bc ml24 theme-default-color"
                        @click="goSubmitForm"
                        >确定</Button
                    >
                </div>
            </Form>
        </Drawer>
        <!-- 参与人数 -->
        <Drawer v-model="countDrawer" title="参与人数" width="80">
            <div>
                <Table :columns="columnCount" :data="dataCount" border>
                    <template slot-scope="{ row }" slot="name">
                        <div>{{ row.customer ? row.customer.name : '' }}</div>
                    </template>
                    <template slot-scope="{ row }" slot="phone">
                        <div>{{ row.customer ? row.customer.phone : '' }}</div>
                    </template>
                </Table>
                <div class="page-drawer">
                    <Page
                        :current="pageCount.page"
                        :page-size="pageCount.limit"
                        :total="totalCount"
                        show-elevator
                        show-total
                        @on-change="goChangePageCount"
                    />
                </div>
            </div>
        </Drawer>
        <pictureLibrary
            v-if="switch_modal"
            :switch_modal.sync="switch_modal"
            :select="imgtype"
            @change="costPlannedAmountChange"
        ></pictureLibrary>
    </div>
</template>

<script>
import {
    points_active,
    points_active_status,
    points_active_delete,
    points_active_info,
    points_active_save,
    points_active_user_list,
    product_select,
    batch_select,
    agent_select,
} from "@/api/index";
import VueQr from "vue-qr";
import pictureLibrary from "@/components/pictureLibrary/pictureLibrary.vue";
export default {
    components: { VueQr, pictureLibrary },
    data() {
        return {
            imgtype: 1,
            switch_modal: false,
            storePrams: {
                page: 1,
                limit: 10,
            },
            total: 0,
            columnsTable: [
                { type: "selection", width: 60, align: "center" },
                { type: "index", width: 60, align: "center" },
                { title: "活动产品", slot: "product", align: "center" },
                { title: "活动总积分", key: "points_sum", align: "center" },
                {
                    title: "已瓜分积分",
                    slot: "user_points_sum_points",
                    align: "center",
                },
                {
                    title: "参与人数",
                    slot: "user_points_count",
                    align: "center",
                },
                { title: "状态", slot: "status", align: "center" },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "200px",
                },
            ],
            dataTable: [],
            drawers: false,
            drawerTitle: "",
            formData: {
                id: "",
                batch_id: "",
                product_id: "",
                agent_id: "",
                mode: 1,
                num: "1",
                points: "1",
                points_sum: "",
                enter_url: "",
                style_url: "",
                word1: "",
                word2: "",
                show_enter_url: "",
                show_style_url: "",
            },
            modeList: [
                { id: 1, name: "固定积分" },
                { id: 2, name: "随机积分" },
            ],
            batchList: [],
            productList: [],
            agentList: [],
            countDrawer: false,
            pageCount: {
                page: 1,
                limit: 10,
                id: "",
            },
            totalCount: 0,
            columnCount: [
                { type: "index", width: 60, align: "center" },
                { title: "姓名", slot: "name", align: "center" },
                { title: "手机号", slot: "phone", align: "center" },
                { title: "积分", key: "points", align: "center" },
                { title: "领取时间", key: "created_at", align: "center" },
            ],
            dataCount: [],
            // selection
            del_id: "",
            delData: [],
            delValue: false,
        };
    },
    mounted() {
        this.getList();
        this.getProductSelect();
        this.getBatchSelect();
        this.getagentSelect();
    },
    methods: {
        // 事件处理函数
        async costPlannedAmountChange(param1, param2) {
            if (this.imgtype === 1) {
                this.formData.show_enter_url = param1[0] || "";
                this.formData.enter_url = param2[0] || "";
                this.$Message.destroy();
            } else if (this.imgtype === 2) {
                this.formData.show_style_url = param1[0] || "";
                this.formData.style_url = param2[0] || "";
                this.$Message.destroy();
            }
        },
        openModal(e) {
            this.imgtype = e;
            this.switch_modal = true;
        },
        getList() {
            points_active(this.storePrams)
                .then((res) => {
                    this.dataTable = res.data.data;
                    this.total = res.data.total;
                    // 删除后，page--
                    if (!res.data.data.length && this.storePrams.page != 1) {
                        this.storePrams.page--;
                        this.getList();
                    }
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        goChangePage(index) {
            this.storePrams.page = index;
            this.getList();
        },
        // 下拉
        getProductSelect() {
            product_select()
                .then((res) => {
                    this.productList = res.data;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        getBatchSelect() {
            batch_select()
                .then((res) => {
                    this.batchList = res.data;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        getagentSelect() {
            agent_select()
                .then((res) => {
                    this.agentList = res.data;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        // Drawer
        goDrawer(row) {
            if (row.id) {
                this.drawerTitle = "编辑积分活动";
                points_active_info({ id: row.id })
                    .then((res) => {
                        this.formData.id = res.data.id;
                        this.formData.batch_id = res.data.batch_id;
                        this.formData.product_id = res.data.product_id;
                        this.formData.agent_id = res.data.agent_id;
                        this.formData.mode = res.data.mode;
                        this.formData.num = res.data.num;
                        this.formData.points = res.data.points;
                        this.formData.points_sum = res.data.points_sum;
                        this.formData.enter_url = res.data.enter_url;
                        this.formData.style_url = res.data.style_url;
                        this.formData.word1 = res.data.word1;
                        this.formData.word2 = res.data.word2;
                        this.formData.show_enter_url = res.data.show_enter_url;
                        this.formData.show_style_url = res.data.show_style_url;
                    })
                    .catch((err) => {
                        this.$Message.error(err.msg);
                    });
            } else {
                this.drawerTitle = "新增积分活动";
                this.formData.id = "";
                this.formData.batch_id = "";
                this.formData.product_id = "";
                this.formData.agent_id = "";
                this.formData.mode = 1;
                this.formData.num = "1";
                this.formData.points = "1";
                this.formData.points_sum = "";
                this.formData.enter_url = "";
                this.formData.style_url = "";
                this.formData.word1 = "";
                this.formData.word2 = "";
                this.formData.show_enter_url = "";
                this.formData.show_style_url = "";
            }
            setTimeout(() => {
                this.drawers = true;
            }, 300);
        },
        goCancelForm() {
            this.drawers = false;
        },
        // 确定(提交表单)
        goSubmitForm() {
            points_active_save(this.formData)
                .then((res) => {
                    this.getList();
                    this.drawers = false;
                    this.$Message.success(res.msg);
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        goDel(index, row) {
            if (index == 0 && this.delData.length == 0) {
                this.$Message.error("请选择");
                return;
            }
            this.$Modal.confirm({
                title: "删除提示",
                content: "确认删除吗？一经删除无法复原",
                onOk: () => {
                    if (index == 0) {
                        const del_id = this.delData.map((item) => item.id);
                        this.del_id = del_id.join(",");
                        points_active_delete({ id: this.del_id })
                            .then((res) => {
                                this.getList();
                                this.delValue = false;
                                this.$Message.success(res.msg);
                            })
                            .catch((err) => {
                                this.$Message.error(err.msg);
                            });
                    } else if (index == 1) {
                        points_active_delete({ id: row.id })
                            .then((res) => {
                                this.getList();
                                this.$Message.success(res.msg);
                            })
                            .catch((err) => {
                                this.$Message.error(err.msg);
                            });
                    }
                },
            });
        },
        goChangeStatus(row, e) {
            this.$Modal.confirm({
                title: "提示",
                content: "确认改变状态吗？",
                onOk: () => {
                    let data = {
                        id: row.id,
                        status: e,
                    };
                    points_active_status(data)
                        .then((res) => {
                            this.getList();
                            this.$Message.success(res.msg);
                        })
                        .catch((err) => {
                            this.$Message.error(err.msg);
                        });
                },
            });
        },
        // 积分领取记录
        getAssemblyWxpacketPrize() {
            points_active_user_list(this.pageCount)
                .then((res) => {
                    this.dataCount = res.data.data;
                    this.totalCount = res.data.total;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        goChangePageCount(index) {
            this.pageCount.page = index;
            this.getAssemblyWxpacketPrize();
        },
        goCount(row) {
            this.pageCount.id = row.id;
            this.getAssemblyWxpacketPrize();
            this.countDrawer = true;
        },
        // selection
        goChangeSelection(e) {
            this.delData = e;
            if (this.dataTable.length === e.length) {
                this.delValue = true;
            } else {
                this.delValue = false;
            }
        },
        goChangeAll(e) {
            if (e == true) {
                this.delData = this.dataTable;
                this.$refs.selection.selectAll(true);
            } else {
                this.$refs.selection.selectAll(false);
            }
        },
        // 删除图片
        goDelEnter() {
            this.formData.show_enter_url = "";
            this.formData.enter_url = "";
        },
        goDelStyle() {
            this.formData.show_style_url = "";
            this.formData.style_url = "";
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.form-title {
    margin-bottom: 24px;
    color: #484e66;
    font-weight: 600;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    height: 100%;
}
.page-container {
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
}
.footer {
    margin: 24px 0 0 0;
    text-align: right;
}
.form-upload {
    width: 100px;
    height: 100px;
    background-color: #fff;
    border: 1px dashed #9fa5bb;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 12px;
}
.form-img {
    width: 100px;
    height: 100px;
    border-radius: 4px;
    position: relative;
}
.img-del {
    position: absolute;
    top: -6px;
    right: -6px;
    cursor: pointer;
}
.wh100 {
    width: 100%;
    height: 100%;
    border-radius: 4px;
}
.dis-flex {
    display: flex;
}
.page-drawer {
    margin-top: 24px;
    text-align: right;
}
::v-deep .ivu-checkbox {
    margin-right: 24px;
}
::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: #ff761d;
    background-color: #ff761d;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
</style>